import React from 'react';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { Form } from 'antd';

// import { Container } from './styles';

const MeetingCandidate = ({ field, index }) => {
  return (
    <Form.Item
      label={index === 0 ? 'Candidatos' : ''}
      {...field}
      validateTrigger={['onChange', 'onBlur']}
      rules={[
        {
          required: true,
          message: "Por Favor, insira uma data ou apague.",
        },
      ]}
      noStyle
      style={{ width: '80%' }}
    >
      <DatePicker
        style={{ width: '80%' }}
        showTime={{ format: 'HH:mm' }}
        format="DD/MM/YYYY HH:mm"
        onChange={(value, string) => {
          return string
        }}
      />
    </Form.Item>
  );
};

export default MeetingCandidate;